if ($('#guided-search--form').length) {
  var stepForm = $(function () {
    var curStep,
      totalSteps = $('.guided-search--content--inner:not(.no-footer)').length,
      curStepNum = $('.cur-step-num'),
      totStepNum = $('.total-step-num');

    $.validator.setDefaults({
      errorLabelContainer: ".messageBox ul",
      errorElement: "li"
    });
    $.validator.addMethod("postalCode", function (value, element) {
      var zipReg = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
      return this.optional(element) || zipReg.test(value);
    }, "Please check your input.");

    var form = $('#guided-search--form');
    var valOptions = {
      groups: {
        bedBath: "bedrooms[] bathrooms[]",
        commute: "zip miles"
      },
      messages: {
        State: {
          required: "You must select a state"
        },
        Area: {
          required: "You must select an area"
        },
        'bedrooms[]': {
          required: "Please choose at least one bedroom and one bathroom option, <br> or select 'Skip this question'."
        },
        'bathrooms[]': {
          required: "Please choose at least one bedroom and one bathroom option, <br> or select 'Skip this question'."
        },
        'timeline[]': {
          required: "Please select at least one move in date range, <br> or select 'Skip this question'."
        },
        'zip': {
          required: "Please enter your zip code and choose a radius before continuing, <br> or select 'Skip this question'.",
          postalCode: "Please enter a valid zip code"
        },
        'miles': {
          required: "Please enter your zip code and choose a radius before continuing, <br> or select 'Skip this question'."
        },
        insights: {
          required: "Please select which is most important to you, <br> or select 'Skip this question and see my results'."
        }
      }
    };
    var validator = form.validate(valOptions);


    $(function () {
      setStepData();
      setSelected();
      $('input[name="zip"]').rules("add", {
        postalCode: "Please enter a valid zip code"
      });
    });

    // Next Button Action
    $('body').on('click', '.guided-search--content--inner .next', function (e) {
      e.preventDefault();

      if ($(e.target).hasClass('no-validate')) {
        clearErrors();
        nextStep();
      } else if (validateFields() === false) {
        return false;
      } else {
        nextStep();
      }
    });
    // Prev Button Action
    $('body').on('click', '.guided-search--footer .prev', function (e) {
      e.preventDefault();
      prevStep(e);
    });
    // Set text based on state/area selections
    $('body').on('change', 'select[name="State"], select[name="Area"]', function (e) {
      setSelected();
    });

    // Finish Button Action
    $('body').on('click', '.guided-search--content--inner .finish', function (e) {
      if (!validateFields()) {
        return false;
      }

      form.submit();
    });
    // Finish Button Action
    $('body').on('click', '.no-validate-finalize', function (e) {
      e.preventDefault();
      clearErrors();
      $('.guided-search--content--inner.active input[type="radio"]').removeAttr('required');​​​​​
      form.submit();
    });

    var validateFields = function (e) {
      var valid = true;
      $('.guided-search--content--inner.active input[type="text"], .guided-search--content--inner.active input[type="checkbox"], .guided-search--content--inner.active input[type="radio"], .guided-search--content--inner.active select').each(function () {
        validator.element(this);
        if ($(this).valid() === false) {
          valid = false;
        }
      });

      return valid;
    }
    // Reload foundation equalizer when slide loads
    var reloadEq = function () {
      Foundation.reInit('equalizer');
    }
    var clearErrors = function () {
      $('.messageBox ul').html('');
    }
    // Set selected fields
    var setSelected = function () {
      $('.selected-state').html($('select[name="State"] option:selected').val());
      $('.selected-state-name').html($('select[name="State"] option:selected').text());
      $('.selected-area').html($('select[name="Area"] option:selected').val());
    }
    // Set the bg image and title when slide loads
    var setStepData = function () {
      var curStep = $('.guided-search--content--inner:not(.no-footer).active').index();

      curStepNum.html(curStep);
      totStepNum.html(totalSteps);

      var title = $('.guided-search--content--inner.active').data('title');
      var bgImage = $('.guided-search--content--inner.active').data('background-image');

      $('.guided-search--container').css({
        'background-image': 'url("' + bgImage + '")'
      });
      $('.guided-search--title strong').html(title);
    }
    var nextStep = function (e) {
      $('.guided-search--content--inner.active').removeClass('active')
        .next('.guided-search--content--inner').addClass('active');

      setStepData();
      reloadEq();
    }
    var prevStep = function () {
      $('.guided-search--content--inner.active').removeClass('active')
        .prev('.guided-search--content--inner').addClass('active');

      setStepData();
      clearErrors();
      reloadEq();
    }
  });

  $(function () {
    $('.advanced-toggle a').click(function () {
      advancedToggle();
    });

    $('.community-toggle a').click(function (e) {
      communityToggle();
    });

    var advancedToggle = function () {
      $('.advanced-toggle a').first().fadeToggle('fast');
      $('.advanced').toggleClass('hidden');
      $('.see-results').first().fadeToggle('fast');
      if ($('#advanced').is(':visible')) {
        $('.advanced-toggle a').text('Hide Advanced Filters');
      } else {
        $('.advanced-toggle a').text('Show Advanced Filters');
        var distance = $('#community-filter').offset().top;
        var offset = $('.nav--main').height();
        $('html, body').animate({
          scrollTop: (distance - offset)
        }, 1000);
      }
    };

    var communityToggle = function () {
      $('#community-filter').toggleClass('hide-for-small-only');
      if ($('#community-filter').is(':visible')) {
        $('.community-toggle .button').text('Hide Search Filters');
      } else {
        $('.community-toggle .button').text('Show Search Filters');
        if ($('#advanced').is(':visible')) {
          $('.advanced-toggle a').first().fadeToggle('fast');
          $('.advanced').toggleClass('hidden');
          $('.see-results').first().fadeToggle('fast');
          $('.advanced-toggle a').text('Show Advanced Filters');
        }
      }
    }
  });

  /* https://github.com/IonDen/ion.rangeSlider */
  $(function () {
    $('.guided-search--container').css({
      'min-height': $(window).innerHeight()
    });

    $('#pricerange-slider').ionRangeSlider({
      type: "double",
      prefix: "$",
      min: 100000,
      max: 1500000,
      step: 25000,
      prettify_separator: ',',
      grid: false,
      hide_min_max: true,
      force_edges: true,
      keyboard: true
    });

    $('#sqft-slider').ionRangeSlider({
      type: "double",
      postfix: " sq. ft.",
      min: 750,
      max: 6000,
      step: 250,
      prettify_separator: ',',
      grid: false,
      hide_min_max: true,
      force_edges: true,
      keyboard: true
    });

    $('#payment-slider').ionRangeSlider({
      type: "double",
      prefix: "$",
      min: 750,
      max: 5000,
      step: 250,
      prettify_separator: ',',
      grid: false,
      hide_min_max: true,
      force_edges: true,
      keyboard: true
    });

    /* The ADA life is the life for me */
    $('.irs-slider.from, .irs-slider.to').each(function () {
      $(this).attr('tabindex', '0');
    });
  })

}